import { render, staticRenderFns } from "./SchedaMorteCauseMorteComponet.vue?vue&type=template&id=4a2019da&scoped=true"
import script from "./SchedaMorteCauseMorteComponet.vue?vue&type=script&lang=js"
export * from "./SchedaMorteCauseMorteComponet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2019da",
  null
  
)

export default component.exports